export const userActionTypes = {
  FETCH_USERS_REQUEST: 'FETCH_USERS_REQUEST',
  FETCH_USERS_SUCCESS: 'FETCH_USERS_SUCCESS',
  FETCH_USERS_FAILURE: 'FETCH_USERS_FAILURE',
}

export const userActions = {
  fetchUsers: (payload, callback) =>
  ({
    type: userActionTypes.FETCH_USERS_REQUEST,
    payload,
    callback
  }),
};

export default userActions;